module.exports = __webpack_public_path__ + "static/media/Tenants.1c20c946.png";